import { Link } from "react-router-dom";
import { ethers } from "ethers";
import { useState } from "react";

import governorAbi from "../Populus/Populus.json";
function NewProposal(props) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const tokenAddress = "0x471B4Ad30ac2FF7207dDC8d223239B740BC06376";
  const contractAddress = "0x93681566B63659db5dacB9FdC3c8934Ae8fcDEcB";
  var provider1 = new ethers.providers.AlchemyProvider(
    "matic",
    "_8TZHcd_cqmy0KNW3bQuBEDWhnnRIzg5"
  );





//   const propose = async () => {
//     const contract = new ethers.Contract(
//       "0x471B4Ad30ac2FF7207dDC8d223239B740BC06376",
//       nftAbi,
//       provider1
//     );
//     console.log("userAddress", accounts[0]);
//     await window.ethereum.enable();
//     const provider = new ethers.providers.Web3Provider(window.ethereum);
//     const signer = provider.getSigner();
//     // const signer = provider.getSigner(props.accountAddress);
//     console.log("hjoe", await contract.connect(signer));
//     const tokenID = await contract.connect(signer).viewTokenID(accounts[0]);
//     const govValue = await contract
//       .connect(signer)
//       .governanceValue(accounts[0]);
//     console.log("tokenID, govValue", tokenID, govValue);
//     setGovernanceValue(govValue);
//     const tokenUri = await contract.connect(signer).tokenURI(tokenID);
//     axios
//       .get(tokenUri)
//       .then(function (response) {
//         // handle success
//         console.log(response);
//         setNftData(response.data);
//       })
//       .catch(function (error) {
//         // handle error
//         console.log(error);
//       })
//       .then(function () {
//         // always executed
//       });
//   };
//   propose();
// }
  const propose = async () => {
    const contract = new ethers.Contract(
      contractAddress,
      governorAbi,
      provider1
    );
    console.log("userAddress", window.ethereum);
    await window.ethereum.enable();
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    // const signer = provider.getSigner(props.accountAddress);
    console.log("hjoe", await contract.connect(signer));
    await contract
      .connect(signer)
      .propose(
        [tokenAddress],
        [0],
        [0x0000000000000],
        title + "~~ENDTITLE~~" + description
      );
  };
  return (
    <div className="widgetStyling">
        <Link to="/">Back</Link>
        <p className="smallTitle noMargin">New Proposal</p>
        <span>Title</span>
        <input value={title} onChange={(e) => setTitle(e.target.value)} />
        <br />
        <br />
        <span>Description</span>
        <input
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        
        <br />
        <br />
        <button onClick={() => propose()}>SUBMIT</button>
      </div>
  );
}

export default NewProposal;
